import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_register_property';

export interface BannerRegisterProperty {
    content_banner_register_property_subtitle: string | null;
    content_banner_register_property_title: string | null;
    content_banner_register_property_description: string | null;
    content_banner_register_property_button_text: string | null;
    content_banner_register_property_link: string | null;
    content_banner_register_property_image: string | null;
}

export interface GetBannerRegisterPropertySuccessResponse {
    data: BannerRegisterProperty;
    success: boolean;
    message: string;
}

export const useGetBannerRegisterProperty = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [banner, setBanner] = useState<BannerRegisterProperty | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar banner register property') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetBannerRegisterPropertySuccessResponse = await response.json();

            setBanner(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar banner register property');
        } finally {
            setLoading(false);
        }
    };

    return { banner, request, loading, error };
};
